module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wallbach_AG-45bd30a8385929f2b60210ac31b8a4fb.svg";